/**
 * The account owner's profile shows their saved name.
 * Other people keep their stored display_name; this helper is only for self.
 * An empty saved name falls back to the account name, then the localized Me label.
 */
export function selfPersonLabel(displayName, meLabel, accountName) {
  const name = typeof displayName === "string" ? displayName.trim() : "";
  if (name) return name;
  const account = typeof accountName === "string" ? accountName.trim() : "";
  if (account) return account;
  return meLabel;
}
